export enum InstanceType {
  JOBS = 'JOBS',
  CANDIDATES = 'CANDIDATES',
  JOB_DETAILS = 'JOB_DETAILS',
  JOB_NAV_BAR_DETAILS = 'JOB_NAV_BAR_DETAILS',
  JOB_DETAILS_UPDATE = 'JOB_DETAILS_UPDATE',
  JOB_AI_ENHANCEMENT = 'JOB_AI_ENHANCEMENT',
  PUBLIC_JOB = 'PUBLIC_JOB',
  ORGANISATION_DETAILS = 'ORGANISATION_DETAILS',
  DUPLICATE_JOB = 'DUPLICATE_JOB',
  WORKFLOW_STAGES = 'WORKFLOW_STAGES',
  WORKFLOW_STAGES_COUNT = 'WORKFLOW_STAGES_COUNT',
  DELETE_JOB = 'DELETE_JOB',
  GET_INVITATIONS = 'GET_INVITATIONS',
  // Add more instance types as needed
}

export const Instances = {
  [InstanceType.JOBS]: {
    endpoint: '/api/jobPostings',
    name: 'GetJobs'
  },
  [InstanceType.CANDIDATES]: {
    endpoint: '/api/candidates',
    name: 'GetCandidates'
  },
  [InstanceType.JOB_DETAILS]: {
    endpoint: '/api/JobPostings',
    name: 'GetJobDetails'
  },
  [InstanceType.JOB_NAV_BAR_DETAILS]: {
    endpoint: '/api/JobPostings',
    name: 'GetJobNavBarDetails'
  },
  [InstanceType.JOB_DETAILS_UPDATE]: {
    endpoint: '/api/JobPostings',
    name: 'UpdateJobDetails'
  },
  [InstanceType.JOB_AI_ENHANCEMENT]: {
    endpoint: '/api/JobPostings',
    name: 'GetAiEnhancement'
  },
  [InstanceType.PUBLIC_JOB]: {
    endpoint: '/api/Public/jobs',
    name: 'GetPublicJob'
  },
  [InstanceType.ORGANISATION_DETAILS]: {
    endpoint: '/api/Public/Organisation',
    name: 'GetOrganisationDetails'
  },
  [InstanceType.DUPLICATE_JOB]: {
    endpoint: '/api/JobPostings',
    name: 'DuplicateJob'
  },
  [InstanceType.WORKFLOW_STAGES]: {
    endpoint: '/api/JobPostings',
    name: 'GetWorkflowStages'
  },
  [InstanceType.WORKFLOW_STAGES_COUNT]: {
    endpoint: '/api/Candidates',
    name: 'GetWorkflowStagesCount'
  },
  [InstanceType.DELETE_JOB]: {
    endpoint: '/api/JobPostings',
    name: 'DeleteJob'
  },
  [InstanceType.GET_INVITATIONS]: {
    endpoint: '/api/Account/Users/Invitations',
    name: 'GetInvitations'
  }
} as const;

export interface InstanceConfig {
  endpoint: string;
  name: string;
}

export type InstancesType = Record<InstanceType, InstanceConfig>; 